export const UPLOADED_IMAGE_LIST_REQUEST = 'UPLOADED_IMAGE_LIST_REQUEST';
